// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee20Filled: FC<MoneyBackGuarantee20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M8.23 16H3.5c-.403 0-.753-.146-1.052-.438A1.43 1.43 0 0 1 2 14.5v-9c0-.403.15-.753.448-1.052A1.44 1.44 0 0 1 3.5 4h13c.403 0 .753.15 1.052.448.299.299.448.65.448 1.052V10h-1.917l-3.75 3.75-2.458-2.48-3.188 3.188L8.23 16Zm4.103 2-3.52-3.542 1.062-1.062 2.458 2.479 4.604-4.604L18 12.333 12.333 18ZM3.5 7v3h13V7h-13Z" />
        </svg>
    );
};

export default MoneyBackGuarantee20Filled;
